export {default} from './template'
export {default as classNames} from './styles.scss'

export const externalLayout = true
